import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
import { DatePipe } from '@angular/common';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/Application/application.html'
})

export class ApplicationComponent implements OnInit {

    userDetail: any;
    public constants: Constants;
    public applications: any[] = [];

    public customers: any[] = [];

    public users: any[] = [];
    public applicationReleaseLogs : any[] = [];

    public addApplicationData: any = {
        addApplicationCustomerId: "",
        addApplicationStatus:true
    };

    public addApplicationLogData: any = {
      //  addApplicationLogReleaseDate: new Date(),
        addApplicationLogReleaseBy: ""
    };



   public filterCustomerStatus: any = "";
   public filterUserStatus: any = "";

    public EditApplicationData: any = {
        editApplicationCustomerId: ""
    };
    public isAdd: boolean = true;
    active = true;
    public showLoader = false;
    public existsApplicationName: boolean = false;
    public isFormSubmitted: boolean = false;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filterCustomerStatus = this.constants.enumCustomerStatus["Active"];
        this.filterUserStatus = this.constants.enumUserStatus["Active"];
    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    ngOnInit() {
        this.getApplications();
        this.getCustomers();
        this.getUsers();
    }

    ExportItems() {

    }

    ngAfterViewInit() {
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });

    }

    public addApplicationFormLoad() {
        $('#btnaddApplicationForm').trigger('click');

        this.addApplicationData = {
            addApplicationCustomerId: '',
            addApplicationStatus:true
        };
    }

    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
    }


    public getCustomers() {
        this.showLoader = true;
        this._httpService.ajaxPost('Customer/GetCustomer', { "CustomerId": 0, "CountryId": 0, "CustomerStatus": this.filterCustomerStatus }).subscribe(
            data => {
                this.customers = data["CustomerList"];
             this.customers.sort(function (a, b) {
                if (a.Customer_Name.toLowerCase() < b.Customer_Name.toLowerCase()) return -1;
                if (a.Customer_Name.toLowerCase() > b.Customer_Name.toLowerCase()) return 1;
                return 0;
            })

            },
            err => {
                this.showLoader = false;
            },

            () => {
                this.showLoader = false;

            }
        );
    }


    public getApplications() {
        this.showLoader = true;

        this._httpService.ajaxPost('Application/getApplication', null
        ).subscribe(
            data => {
                this.applications = data["Application"];
               // var datePipe = new DatePipe();
                // this.applications.forEach(element => {
                //     element.ReleaseDate = this._datepipe.transform(element.ReleaseDate, 'dd/MM/yyyy');
                // });

            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getUsers() {
        this.showLoader = true;
        this._httpService.ajaxPost('Users/GetAllUsers', {
            "IsActive": this.filterUserStatus
        }).subscribe(
            data => {
                this.users = data["Users"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
            );
    }



    public getApplicationLogs(item: any) {

        this.showLoader = true;
        this._httpService.ajaxPost('Application/GetApplicationReleaseLogs', {
            "ApplicationId": item.ApplicationId
        }).subscribe(
            data => {
                this.applicationReleaseLogs = data["ApplicationReleaseLogs"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
            );
    }


    public CanceladdApplication() {
        this.existsApplicationName = false;
        this.addApplicationData = {
            addApplicationCustomerId: "",
            addApplicationStatus:true
        };

        this.newForm();
        $('#addApplication').modal('hide');
        this.isAdd = true;
    }

    public CancelEditApplication() {
        this.existsApplicationName = false;
        this.EditApplicationData = {};
        this.newForm();
        $('#EditApplication').modal('hide');
        this.isAdd = true;
    }

    public addApplication(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsApplicationName = false;
            this.applications.forEach(element => {
                if (element.ApplicationName.trim().toLowerCase() == this.addApplicationData.addApplicationName.trim().toLowerCase()) {
                    this.existsApplicationName = true;
                }
            });

            if (!this.existsApplicationName) {
                let objItem: any = {};

                objItem.ApplicationId = 0;
                objItem.CustomerId = this.addApplicationData.addApplicationCustomerId;
                objItem.ApplicationName = this.addApplicationData.addApplicationName;
                objItem.Status = this.addApplicationData.addApplicationStatus;

                this.addEditApplication(objItem);

                $('#addApplication').modal('hide');
                this.addApplicationData = {};
                this.newForm();
                this.isAdd = true;
            }
        }
    }


     public addApplicationLogFormLoad(item: any) {
        $('#btnaddApplicationLogForm').trigger('click');
        this.addApplicationLogData.ApplicationId = item.ApplicationId;
        this.addApplicationLogData.ApplicationName = item.ApplicationName;
        this.addApplicationLogData.ReleaseNumber = item.ReleaseNumber;
        this.addApplicationLogData.Customer_Name = item.Customer_Name;

        setTimeout(() =>
            $('.date').datetimepicker({
                format: 'DD/MM/YYYY'
            })
        , 100);
    }

    public EditApplication(item: any) {
        $('#btnEditApplicationForm').trigger('click');
        this.isAdd = false;
        this.EditApplicationChange(item.ApplicationId);

    }

    public EditApplicationChange(itemId) {
        let objItem: any = {};
        objItem = JSON.parse(JSON.stringify(this.applications.filter((application) => application.ApplicationId == itemId)[0]));
        this.EditApplicationData.editApplicationId = objItem.ApplicationId;
        this.EditApplicationData.editApplicationName = objItem.ApplicationName;
        this.EditApplicationData.editApplicationCustomerId = objItem.CustomerId;
        this.EditApplicationData.editApplicationStatus = objItem.Status;
    }

    public UpdateApplication(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsApplicationName = false;
            this.applications.forEach(element => {
                if (element.ApplicationId != this.EditApplicationData.editApplicationId && element.ApplicationName.trim().toLowerCase() == this.EditApplicationData.editApplicationName.trim().toLowerCase()) {
                    this.existsApplicationName = true;
                }
            })

            if (!this.existsApplicationName) {
                let objItem: any = {};

                objItem.ApplicationId = this.EditApplicationData.editApplicationId;
                objItem.CustomerId = this.EditApplicationData.editApplicationCustomerId;
                objItem.ApplicationName = this.EditApplicationData.editApplicationName;
                objItem.Status = this.EditApplicationData.editApplicationStatus;


                this.addEditApplication(objItem);
                $('#EditApplication').modal('hide');
                this.EditApplicationData = {};
                this.newForm();
                this.isAdd = true;
            }
        }
    }

    addEditApplication(objItem) {

    //    objItem.Created_By = this.userDetail.SiteUserId;
    //    objItem.Modified_By = this.userDetail.SiteUserId;

        this.showLoader = true;

        this._httpService.ajaxPost('Application/AddUpdateApplication', objItem).subscribe(
            data => {
                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                this.getApplications();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public CanceladdApplicationLog() {

        this.addApplicationLogData = {
      //  addApplicationLogReleaseDate: new Date(),
            addApplicationLogReleaseBy:""
        };

        this.newForm();
        $('#AddApplicationLog').modal('hide');

    }

    public addApplicationLog(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {

                let objItem: any = {};

                objItem.ApplicationId = this.addApplicationLogData.ApplicationId;
                objItem.ReleaseBy = this.addApplicationLogData.addApplicationLogReleaseBy;
                objItem.ReleaseDate = this.addApplicationLogData.addApplicationLogReleaseDate;
                objItem.ReleaseNote = this.addApplicationLogData.addApplicationLogReleaseNote;
                objItem.ReleaseNumber = this.addApplicationLogData.addApplicationLogReleaseNo;

                this.addUpdateApplicationLog(objItem);

                $('#AddApplicationLog').modal('hide');
                this.addApplicationLogData = {};
                this.newForm();


        }
    }

    addUpdateApplicationLog(objItem) {

    //    objItem.Created_By = this.userDetail.SiteUserId;
    //    objItem.Modified_By = this.userDetail.SiteUserId;

        this.showLoader = true;

        this._httpService.ajaxPost('Application/AddUpdateApplicationReleaseLog', objItem).subscribe(
            data => {
                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                this.getApplications();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Application/application.component.ts
 **/